import HealthHiringInsuredMedicalSituation from '@/modules/health/hiring/models/APP/HealthHiringInsuredMedicalSituation'
import HealthHiringInsuredHealthSituation from '@/modules/health/hiring/models/APP/HealthHiringInsuredHealthSituation'
import Insured from '@/modules/common/common/models/APP/Insured'

export default class HealthHiringInsured extends Insured {
  private _anotherCompany!: boolean | null

  private _medicalSituation = new HealthHiringInsuredMedicalSituation()
  private _healthSituation = new HealthHiringInsuredHealthSituation()

  constructor(data: Partial<HealthHiringInsured> = {}) {
    super(data)

    this.anotherCompany = data.anotherCompany
    this.medicalSituation = data.medicalSituation
    this.healthSituation = data.healthSituation
  }

  get anotherCompany(): boolean | null {
    return this._anotherCompany
  }
  set anotherCompany(value: boolean | null | undefined) {
    this._anotherCompany = value ?? null
  }

  get medicalSituation(): HealthHiringInsuredMedicalSituation {
    return this._medicalSituation
  }
  set medicalSituation(value: HealthHiringInsuredMedicalSituation | null | undefined) {
    this._medicalSituation.updateAttributes(value ?? {})
  }

  get healthSituation(): HealthHiringInsuredHealthSituation {
    return this._healthSituation
  }
  set healthSituation(value: HealthHiringInsuredHealthSituation | null | undefined) {
    this._healthSituation.updateAttributes(value ?? {})
  }
}
